export const getAcademyReply = (message) => {
  try {
    const raw = typeof message === "string" ? JSON.parse(message) : message;
    const reply = raw?.academy;
    if (!reply || typeof reply !== "object" || Array.isArray(reply)) return null;
    return {
      ...reply,
      options: (Array.isArray(reply.options) ? reply.options : []).filter(
        (option) => option && [option.id, option.label]
          .every((value) => typeof value === "string" && value.trim()) &&
          (option.action == null || typeof option.action === "string"),
      ),
    };
  } catch {
    return null;
  }
};

export const createAcademySelection = (option, reply, sourceMessageId) => ({
  sourceMessageId,
  optionId: option.id,
  ...(typeof option.action === "string" && option.action.trim()
    ? { action: option.action.trim() } : {}),
  videoNumber: Number.isInteger(reply.videoNumber) ? reply.videoNumber : null,
});

export const createAcademyVideoCompletion = (reply, sourceMessageId) => {
  const videoNumber = reply?.videoNumber;
  if (!Number.isInteger(videoNumber) || videoNumber <= 0 || !sourceMessageId) return null;
  return { sourceMessageId, videoNumber };
};

export const getLatestAcademyMessageId = (groups, botUserId) =>
  (groups || []).flatMap((group) => group.messages || [])
    .filter((message) => !message.isdeleted && !message.isdraft &&
      message.senderid?.toLowerCase() === botUserId?.toLowerCase())
    .sort((a, b) => new Date(b.time || 0) - new Date(a.time || 0))[0]?.messageid;
